import { route } from 'react-router-typesafe-routes';

export const ROUTES = {
  LOGIN: route({ path: '' }),
  MAP: route({ path: 'map' }),
  HELP: route({ path: 'help' }),
  POPUP: route({
    path: 'popup',
    children: {
      REPORT: route({ path: 'report' }),
      TARGETS: route({ path: 'targets' }),
    },
  }),
  SETTINGS: route({
    path: 'settings',
    children: {
      GENERAL: route({ path: 'general' }),
      MAP: route({ path: 'map' }),
      WEB_MAP_SERVICES: route({ path: 'web-map-services' }),
      VECTOR_TILES: route({ path: 'vector-tiles' }),
      BASE_MAP: route({ path: 'base-map' }),
      BOOKMARKS: route({ path: 'bookmarks' }),
      CHANGE_PASSWORD: route({ path: 'change-password' }),
      MULTIFACTOR: route({ path: 'multifactor' }),
    },
  }),
  MULTIFACTOR: route({
    path: 'multifactor',
    children: {
      BEFORE_LOGIN: route({ path: 'before-login' }),
      AUTHENTICATED: route({ path: 'authenticated' }),
    },
  }),
  AUTHENTICATION: route({
    path: 'authentication',
    children: {
      CHANGE_PASSWORD: route({ path: 'change-password' }),
    },
  }),
};
